import { Box, Checkbox, Flex, FormControl, FormErrorMessage, Select, Tooltip } from '@chakra-ui/react'
import { WizardTravelAdditionalData } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'react-hook-form'
import { SelectionType, Selection, Risk, Insurer } from 'brokertslib/src/enums'
import { FormGroup } from '../components/FormGroup'
import { FormLabel } from '../components/FormLabel'
import { FormSpacer } from '../components/FormSpacer'
import { InputGroup } from '../components/InputGroup'
import { PhoneInputGroup } from '../components/PhoneInputGroup'
import { Radio } from '../components/Radio'
import { RadioGroup } from '../components/RadioGroup'
import { RadioStack } from '../components/RadioStack'
import { GetFormItemName, useNameof } from '../hooks/useNameof'
import { Info } from '../icons'
import { BCNOptions } from './BCNOptions'
import { InsureeAddress } from './InsureeAddress'
import { InsureeName } from './InsureeName'
import { InsureeType } from './InsureeType'
import { ICOOptions } from './ICOOptions'
import { nameof } from 'ts-simple-nameof'
import { useInsuranceParamsContext } from '../layouts/Wizard'
import { useSelections } from '../hooks'
import InsureeContact from './InsureeContact'

interface AdditionalInsureeCestovkoInfoProps {
  hideContacts?: boolean
  hideInsuranceSubject?: boolean
}

export const AdditionalInsureeCestovkoInfo = ({
  hideContacts,
  hideInsuranceSubject,
}: AdditionalInsureeCestovkoInfoProps) => {
  const { insuranceParams } = useInsuranceParamsContext()
  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { data: dataTitles, isLoading: isLoadingTitles, isFetching: isFetchingTitles } = useSelections(SelectionType.TitleBefore)

  const {
    control,
    register,
    watch,
    getValues,
    getFieldState
  } = useFormContext<WizardTravelAdditionalData>()

  const nameof = useNameof<WizardTravelAdditionalData>()

  const phType = watch('policyHolder.type')
  const { error: agreementError } = getFieldState('policyHolder.agreement')
  const insurerId = getValues('insurerId')

  return (
    <>
      <InsureeType personPrefix={nameof(x => x.policyHolder)} disabled />

      <FormSpacer />

      {insurerId == Insurer.CPP &&
        [Selection.Company, Selection.SelfEmployed].includes(phType) &&
        <FormControl >
          <Flex sx={{ gap: 2 }}>
            <Checkbox {...register('policyHolder.isVatPayer')} isDisabled={isContracted}>
              Plátce DPH
            </Checkbox>
          </Flex>
        </FormControl>
      }

      {[Selection.Person, Selection.SelfEmployed].includes(phType) &&
        <>
          <BCNOptions personPrefix={nameof(x => x.policyHolder)} disabled />
          <FormGroup>
            <FormControl>
              <FormLabel>Titul před jménem</FormLabel>

              {(dataTitles?.data.length ?? 0) > 0 &&
                <Select
                  {...register('policyHolder.titleBefore')}
                  isDisabled={isContracted}
                  defaultValue={getValues('policyHolder.titleBefore') ?? ''}
                >
                  <option value=''>Vyberte</option>
                  {dataTitles?.data.map((item) => (
                    <option value={item.value?.toString()} key={item.id}>{item.value}</option>
                  ))}
                </Select>
              }
            </FormControl>

            <InsureeName personPrefix={nameof(x => x.policyHolder)} isDisabled />

            <FormControl>
              <FormLabel>Titul za jménem</FormLabel>

              <InputGroup placeholder="Např. PhD." htmlSize={8} {...register('policyHolder.titleAfter')} isDisabled={isContracted} />
            </FormControl>
          </FormGroup>
        </>
      }

      {[Selection.Company, Selection.SelfEmployed].includes(phType) && <ICOOptions personPrefix={nameof(x => x.policyHolder)} showAgent={getValues('policyHolder.agent.required') ?? false} />}

      <FormSpacer />

      <InsureeAddress addressPrefix={nameof(x => x.policyHolder!.address)} street isDisabled={isContracted} isDisabledStreet={isContracted} />

      <InsureeContact personPrefix={nameof(x => x.policyHolder)} isDisabled={isContracted} emailRequired mobileRequired />

      <FormControl isInvalid={!!agreementError?.message}>
        <Flex sx={{ gap: 2 }}>
          <Checkbox {...register('policyHolder.agreement')} isDisabled={isContracted}>
            Souhlas s elektronickou komunikací
          </Checkbox>
          <Tooltip
            shouldWrapChildren
            hasArrow
            label="Souhlas s elektronickou komunikací"
            placement="top"
          >
            <Info color="blue.500" />
          </Tooltip>
        </Flex>
        {<FormErrorMessage>{agreementError?.message}</FormErrorMessage>}
      </FormControl>

      <FormSpacer />

      {/* {!hideInsuranceSubject && (
        <>
          <FormControl>
            <FormLabel>Pojištění je sjednáváno pro</FormLabel>

            <RadioGroup name="insuranceSubject" control={control}>
              <RadioStack variant="stackedTile">
                <Radio value="subject">Sebe nebo rodinu</Radio>
                <Radio value="third-party">Třetí osobu</Radio>
              </RadioStack>
            </RadioGroup>
          </FormControl>

          {insuranceSubject === 'third-party' && (
            <FormControl sx={{ width: '100%' }}>
              <FormLabel>Bližší specifikace</FormLabel>

              <InputGroup
                name="thirdPartySpecification"
                htmlSize={120}
                placeholder="Přiblížení sjednání pro třetí osobu"
                sx={{ width: '100%' }}
              />
            </FormControl>
          )}
        </>
      )} */}
    </>
  )
}
